import { render } from "./PlanosCoberturaView.vue?vue&type=template&id=d2c349dc"
import script from "./PlanosCoberturaView.vue?vue&type=script&lang=js"
export * from "./PlanosCoberturaView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__